import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: null,
    company: {},
    project: {},
  },
  getters: {
    getUser: state => state.user,
    uid: state => state.user.uid,
    permission: (state) => {
      if(state.project.version && state.project.version.id) {
        return {
          ...state.project,
          deadline_accounting: state.project.version.deadline_accounting,
          progress: state.project.version.progress,
          price: state.project.version.price,
          unit_name: state.project.version.unit_name
        }
      }


      return state.project
    }
  },
  mutations: {
    SET_USER: state => {
      state.user = authFirestore.currentUser;
    },
    SET_CURRENT_PROJECT: (state, project) => {
      state.project = {
        ...state.project,
        ...project,
      };
    },
    RESET_CURRENT_PROJECT: (state, project) => {
      state.project = {
        ...project,
      };
    },
    SET_COMPANY: (state, company) => {
      state.company = company;
    },
    CLEAR_COMPANY: (state) => {
      state.company = {}
    }
  },
  actions: {
    setUser: context => {
      context.commit('SET_USER');
    },

    clearCompany(context) {
      context.commit('CLEAR_COMPANY');
    },

    setCompany: (context, company) => {
      context.commit('SET_COMPANY', company);
    },

    setProject: (context, project) => {
      context.commit('SET_CURRENT_PROJECT', project);
    },
    resetProject: (context, project) => {
      context.commit('RESET_CURRENT_PROJECT', project);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js